const AGToken = "AGTOKEN"
const AGSessionTokenTime = "AGSESSIONTOKENTIME"
const JourneyList = "JOURNEYLIST"
const PhoneCode = "PHONECODE"
const PhoneNbr = "PHONENBR"
const HotelId = " HOTELID"
const DraftOwner = "DRAFTOWNER"

const localstorage = {
  getToken() {
    return sessionStorage.getItem(AGToken)
  },
  SaveSessionToken(token: string) {
    sessionStorage.setItem(AGToken, token)
  },
  GetSessionTokenTime() {
    return sessionStorage.getItem(AGSessionTokenTime)
  },
  SaveSessionTokenTime(epochTime: string) {
    sessionStorage.setItem(AGSessionTokenTime, epochTime)
  },
  saveHotelId(hotelId: string) {
    return sessionStorage.setItem(HotelId, hotelId)
  },
  getHotelId() {
    return sessionStorage.getItem(HotelId)
  },
  getJourney() {
    return sessionStorage.getItem(JourneyList)
  },
  saveJourney(journey: string) {
    return sessionStorage.setItem(JourneyList, journey)
  },
  GetPhoneCode() {
    return sessionStorage.getItem(PhoneCode)
  },
  SavePhoneCode(phonecode: string) {
    return sessionStorage.setItem(PhoneCode, phonecode)
  },
  GetPhoneNbr() {
    return sessionStorage.getItem(PhoneNbr)
  },
  SavePhoneNbr(phonenbr: string) {
    return sessionStorage.setItem(PhoneNbr, phonenbr)
  },
  saveDraftOwner(hotelId: string, groupId: string) {
    return sessionStorage.setItem(DraftOwner, `${hotelId}/${groupId}`)
  },
  isDraftOwner(hotelId: string, groupId: string) {
    return sessionStorage.getItem(DraftOwner) === `${hotelId}/${groupId}`
  },
  clearDraft() {
    const draftKeys = [JourneyList, PhoneCode, PhoneNbr, DraftOwner]
    draftKeys.forEach((key) => sessionStorage.removeItem(key))
  },
  clear() {
    return sessionStorage.clear()
  },
}
export default localstorage
